var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTempSnapChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5714 5.99572C13.5714 -0.930864 4.42857 -0.930864 4.42857 5.99572V7.15015H3.18819C2.744 7.15015 2.56114 7.72659 2.92305 7.9875L4.42857 9.0742C4.17486 9.97235 3.13333 11.9218 1 12.5375C1.25371 12.9223 1.99048 13.6919 2.90476 13.6919L3.66667 14.8464L5.57143 14.4615C6.2061 14.9749 7.78095 16.0008 9 16.0008C10.219 16.0008 11.7939 14.9749 12.4286 14.4615L14.3333 14.8464L15.0952 13.6919C16.0095 13.6919 16.7463 12.9223 17 12.5375C14.8667 11.9218 13.8251 9.97235 13.5714 9.0742L15.077 7.9875C15.4389 7.72659 15.256 7.15015 14.8118 7.15015H13.5714V5.99572Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempSnapChat);
export default __webpack_public_path__ + "static/media/tempSnapChat.61a23437d56eb690b1b7812f2d4e1ecb.svg";
export { ForwardRef as ReactComponent };